import React from 'react';
import {
  Box,
  Container,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Icon,
  useColorModeValue
} from '@chakra-ui/react';
import { FiLayers, FiPackage } from 'react-icons/fi';
import NiveauManagement from './NiveauManagement';
import AdminPacksManager from './AdminPacksManager';

const EducationManagement = () => {
  const bgColor = useColorModeValue('#f8f9fa', 'gray.900');
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';

  return (
    <Box dir="rtl" bg={bgColor} minH="100vh" py={8}>
      <Container maxW="1600px">
        <Heading size="xl" mb={8} color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="900">
          إدارة التعليم (المستويات والباقات)
        </Heading>

        <Box bg="white" borderRadius="2xl" boxShadow="xl" overflow="hidden">
          <Tabs variant="enclosed" colorScheme="blue" size="lg" isLazy>
            <TabList bg="gray.50" pt={4} px={4} borderBottom="2px solid" borderColor="gray.100">
              <Tab
                _selected={{ color: 'blue.600', bg: 'white', borderColor: 'gray.200', borderBottomColor: 'white' }}
                fontFamily="Tajawal, sans-serif"
                fontWeight="800"
                borderTopRadius="xl"
                display="flex"
                alignItems="center"
                gap={2}
              >
                <Icon as={FiLayers} />
                إدارة المستويات
              </Tab>
              <Tab
                _selected={{ color: 'orange.500', bg: 'white', borderColor: 'gray.200', borderBottomColor: 'white' }}
                fontFamily="Tajawal, sans-serif"
                fontWeight="800"
                borderTopRadius="xl"
                display="flex"
                alignItems="center"
                gap={2}
              >
                <Icon as={FiPackage} />
                إدارة الباقات
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel p={0}>
                <Box p={{ base: 4, md: 8 }}>
                  <NiveauManagement />
                </Box>
              </TabPanel>
              <TabPanel p={0}>
                <Box p={{ base: 4, md: 8 }}>
                  <AdminPacksManager />
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Container>
    </Box>
  );
};

export default EducationManagement;
